import { useAxios } from '../utils/axiosConfig';
import config from '../contexts/ConfigContext'
import { useNotification } from 'contexts/NotificationContext';



export interface ProjectNotificationEmailModel {
    Id: number;
    Email: string;
    ProjectId: number;
}


class ProjectNotificationEmailService {
    axios = useAxios();
    notification = useNotification();
    
    async GetProjectNotificationEmails(): Promise<ProjectNotificationEmailModel[]> {
        try {
            const response = await this.axios.get(`${config.API_URL}/api/ProjectNotificationEmails`);
            return response.data as ProjectNotificationEmailModel[];
        } catch (error) {
            throw error;
        }
    }  
    async AddProjectEmail(projectNotificationEmail: ProjectNotificationEmailModel): Promise<any> {
        console.log("Adding project notification email: ", projectNotificationEmail);
        try {
            const response = await this.axios.post(config.API_URL + "/api/ProjectNotificationEmails/", projectNotificationEmail);
            this.notification.showNotification("Email added for project" ,'info');
            return response.data;
        }
        catch (error) {
            this.notification.showNotification("Error adding email: " + error, 'error');
            return null;
        }
    }

    async UpdateProjectEmail(projectNotificationEmail: ProjectNotificationEmailModel): Promise<any> {
        try {
            const response = await this.axios.put(config.API_URL + "/api/ProjectNotificationEmails/", projectNotificationEmail);
            this.notification.showNotification("Email updated for project" ,'info');
            return response.data;
        }
        catch (error) {
            this.notification.showNotification("Error updating email: " + error, 'error');
            return null;
        }
    }  
    async DeleteAnnotation(projectNotificationEmailId: number): Promise<any> {
        try {
            const response = await this.axios.delete(`${config.API_URL}/api/ProjectNotificationEmails`, { params: { id: projectNotificationEmailId } });
            this.notification.showNotification("Email deleted for project" ,'info');
            return response.data;
        }
        catch (error) {
            this.notification.showNotification("Error deleting Email: " + error, 'error');
            return null;
        }
    }
}

export default ProjectNotificationEmailService;